import React from 'react';


const FormHeader = ({
  onInstructionsClick,
  onBingClick,
  isDark
}) => {
  return (
    <div className="flex flex-col gap-[24px] items-center w-full max-w-[822px]">
      {/* Title and subtitle section */}
      <div className="flex flex-col gap-[6px] items-center justify-center w-full">
        <h1 className={`m-0 font-semibold text-[20px] text-center whitespace-nowrap transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          Mailroom Form
        </h1>
        <p className={`m-0 font-normal text-[16px] text-center transition-colors duration-200 ${
          isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
        }`}>
          Please provide the following details. Fields with <span className="text-[#ff0000]">*</span> are required.
        </p>
      </div>

      {/* Action buttons */}
      <div className="flex flex-col sm:flex-row gap-[24px] items-start justify-center pb-[15px]">
        <button
          type="button"
          onClick={onBingClick}
          className={`px-[16px] py-[12px] rounded-[12px] flex items-center justify-center gap-[10px] border-0 cursor-pointer transition-colors duration-200 ${
            isDark
              ? 'bg-[#cd6d2c] hover:bg-[#ffffff]'
              : 'bg-[#cd6d2c] hover:bg-[#072837]'
          }`}
        >
          <div className="flex items-center gap-[4px]">
            <span className={`font-semibold text-[16px] whitespace-nowrap transition-colors duration-200 ${
              isDark ? 'text-[#000000]' : 'text-white'
            }`}>
              Click to see Bing time frames
            </span>
          </div>
          <div
            className="w-[16px] h-[16px]"
            style={{
              backgroundColor: isDark ? '#000000' : '#ffffff',
              WebkitMaskImage: "url('/assets/icons/pdf.svg')",
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              WebkitMaskPosition: 'center',
              maskImage: "url('/assets/icons/pdf.svg')",
              maskRepeat: 'no-repeat',
              maskSize: 'contain',
              maskPosition: 'center',
              transition: 'background-color 0.2s ease'
            }}
            aria-hidden="true"
          />
        </button>

        <button
          type="button"
          onClick={onInstructionsClick}
          className={`group border-solid border-[1px] px-[16px] py-[12px] rounded-[12px] flex items-center justify-center gap-[10px] cursor-pointer transition-colors duration-200 ${
            isDark
              ? 'bg-[#161515] border-[#292929] hover:bg-white [&>div>span]:hover:text-black [&>div>span]:text-white'
              : 'bg-[#fff5eb] border-[#072837] hover:bg-[#072837] [&>div>span]:hover:text-white [&>div>span]:text-[#072837]'
          }`}
          style={{
            '--icon-color': isDark ? '#ffffff' : '#072837',
            '--icon-hover-color': isDark ? '#072837' : '#ffffff'
          }}
        >
          <div className="flex items-center gap-[4px]">
            <span className="font-semibold text-[16px] whitespace-nowrap transition-colors duration-200">
              Click here for instructions
            </span>
          </div>
          <div
            className="w-[16px] h-[16px] transition-colors duration-200 instruction-icon"
            style={{
              backgroundColor: 'var(--icon-color)',
              WebkitMaskImage: "url('/assets/icons/instructions.svg')",
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              WebkitMaskPosition: 'center',
              maskImage: "url('/assets/icons/instructions.svg')",
              maskRepeat: 'no-repeat',
              maskSize: 'contain',
              maskPosition: 'center',
              transition: 'background-color 0.2s ease',
            }}
            aria-hidden="true"
          />
          <style jsx>{`
            button:hover .instruction-icon {
              background-color: var(--icon-hover-color) !important;
            }
          `}</style>
        </button>
      </div>
    </div>
  );
};

export default FormHeader;